import { ERROR_MAINTENANCE, TOKEN_EXPIRED, AUTHENTICATED_USER_PASSWORD, AUTHENTICATED_USER, TOKEN } from './../../app.constant';
import { Router } from "@angular/router";

import { BasicAuthenticationService } from "./../../auth/basic-authentication.service";
import { Injectable } from "@angular/core";
import {
  HttpInterceptor,
  HttpHandler,
  HttpRequest,
  HttpClient,
  HttpResponse,
  HttpEvent,
  HttpErrorResponse
} from "@angular/common/http";
import { map, catchError } from "rxjs/operators";
import { throwError } from 'rxjs';

@Injectable({
  providedIn: "root"
})
export class HttpIntercepterBasicAuthService implements HttpInterceptor {

  systemIsInMaintenanceMode: boolean = false;

  constructor(private router: Router, private http: HttpClient, private basicAuthenticationService: BasicAuthenticationService) { }

  intercept(request: HttpRequest<any>, next: HttpHandler) {

    let modifiedReq;

    if (sessionStorage.getItem(TOKEN) != null) {
      modifiedReq = request.clone({
        headers: request.headers.set('TOKEN', sessionStorage.getItem(TOKEN)),
      });
    }
    else {
      modifiedReq = request.clone({
        headers: request.headers.set('TOKEN', ''),
      });
    }

    console.log('Request URL: ' + modifiedReq.urlWithParams);
    console.log('Request Body: ' + JSON.stringify( modifiedReq.body));

    return next.handle(modifiedReq).pipe(
      map((event: HttpEvent<any>) => {
        if (event instanceof HttpResponse) {

          //console.log('Response: '+  JSON.stringify(event));

          console.log('Response: '+ JSON.stringify(event.body));

          var firstKey = Object.keys(event.body)[0];

          if (firstKey.toUpperCase() == 'ERROR') {
            if (event.body[firstKey] == ERROR_MAINTENANCE) {
              this.basicAuthenticationService.logout()
              this.router.navigate(['maintenance']);
            }
            else
              if (event.body[firstKey] == TOKEN_EXPIRED) {

                let userName = sessionStorage.getItem(
                  AUTHENTICATED_USER
                );
                let password = sessionStorage.getItem(
                  AUTHENTICATED_USER_PASSWORD
                );


                this.basicAuthenticationService.executeObsAuthenticationService(
                  userName, password
                ).subscribe(
                  response => {

                    // var firstKey = Object.keys(response)[0];

                    // var systemConfig: SystemConfig;

                    // if (firstKey.toUpperCase() == "OK") {
                    //   systemConfig = response[firstKey];

                    //   console.log("IN_MAINTENANCE_MODE: " + systemConfig.value);

                    //   if (systemConfig.value == IN_OPERATION_MODE) {
                    //   } else if (systemConfig.value == IN_MAINTENANCE_MODE) {
                    //     this.basicAuthenticationService.clearSession();
                    //     this.router.navigate(["maintenance"]);
                    //   }
                    // } else if (firstKey.toUpperCase() == "ERROR") {
                    //   // show error message returned from REST API
                    //   this.updateAlertArray(response[firstKey], false);
                    // }
                  },
                  error => {
                    this.router.navigate(['login']);
                  }
                );
              }
          }

        }
        return event;
      }),
      catchError((error: HttpErrorResponse) => {
        let data = {};
        data = {
          // domain: error.domain,
          message: error.message,
          //reason: error.reason
        };
        console.log(data);
        return throwError(error);
      })
    );
  }
}
